/**
 * JB WELD CUSTOM PRODUCT PAGE SCRIPTS
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initGallery();
    initQuantityButtons();
    initStickyNav();
    initSmoothScroll();
    initApplicationSteps();
    initProductNavigation();
    initVideoPlayers();
    initImageZoom();
  }

  /**
   * Image Zoom - Lightbox with click-to-magnify + pan
   */
  function initImageZoom() {
    const buttons = document.querySelectorAll('.jbweld-zoom-btn');
    if (!buttons.length) return;

    const overlay = document.createElement('div');
    overlay.className = 'jbweld-zoom-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Zoomed image');
    overlay.innerHTML =
      '<button type="button" class="jbweld-zoom-close" aria-label="Close">&times;</button>' +
      '<div class="jbweld-zoom-stage"><img class="jbweld-zoom-img" alt=""></div>';
    document.body.appendChild(overlay);

    const stage = overlay.querySelector('.jbweld-zoom-stage');
    const img = overlay.querySelector('.jbweld-zoom-img');
    const closeBtn = overlay.querySelector('.jbweld-zoom-close');
    let lastTrigger = null;

    function setOrigin(clientX, clientY) {
      const rect = stage.getBoundingClientRect();
      const x = ((clientX - rect.left) / rect.width) * 100;
      const y = ((clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = Math.min(Math.max(x, 0), 100) + '% ' + Math.min(Math.max(y, 0), 100) + '%';
    }

    function open(btn) {
      lastTrigger = btn;
      img.src = btn.getAttribute('data-zoom-src');
      img.alt = btn.getAttribute('data-zoom-alt') || '';
      overlay.classList.remove('zoomed');
      img.style.transformOrigin = '50% 50%';
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function close() {
      overlay.classList.remove('open', 'zoomed');
      document.body.style.overflow = '';
      if (lastTrigger) lastTrigger.focus();
    }

    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        open(this);
      });
    });

    img.addEventListener('click', function(e) {
      e.stopPropagation();
      setOrigin(e.clientX, e.clientY);
      overlay.classList.toggle('zoomed');
    });

    stage.addEventListener('mousemove', function(e) {
      if (overlay.classList.contains('zoomed')) setOrigin(e.clientX, e.clientY);
    });

    stage.addEventListener('touchmove', function(e) {
      if (!overlay.classList.contains('zoomed') || e.touches.length !== 1) return;
      e.preventDefault();
      setOrigin(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: false });

    stage.addEventListener('click', function(e) {
      if (e.target === stage) close();
    });
    closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('open')) close();
    });
  }

  /**
   * Gallery - Thumbnail & Main Image Switching
   */
  function initGallery() {
    const thumbnails = document.querySelectorAll('.jbweld-thumbnail');
    const mediaItems = document.querySelectorAll('.jbweld-media-item');

    if (!thumbnails.length || !mediaItems.length) return;

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        const index = this.getAttribute('data-media-index');
        
        // Update active thumbnail
        thumbnails.forEach(function(t) {
          t.classList.remove('active');
        });
        this.classList.add('active');

        // Update active media and reset videos
        mediaItems.forEach(function(media) {
          if (media.getAttribute('data-media-index') === index) {
            media.classList.add('active');
          } else {
            media.classList.remove('active');
            
            // Reset video players to preview state
            const preview = media.querySelector('.jbweld-video-preview');
            const player = media.querySelector('.jbweld-video-player');
            if (preview && player) {
              preview.style.display = 'flex';
              player.classList.add('hidden');
              const video = player.querySelector('video');
              if (video) {
                video.pause();
                video.currentTime = 0;
              }
            }
          }
        });
      });
    });
  }

  /**
   * Quantity Buttons - Increase/Decrease
   */
  function initQuantityButtons() {
    const qtyButtons = document.querySelectorAll('.jbweld-qty-btn');

    qtyButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const action = this.getAttribute('data-action');
        const input = this.parentElement.querySelector('.jbweld-qty-input');
        let value = parseInt(input.value) || 1;

        if (action === 'increase') {
          value++;
        } else if (action === 'decrease' && value > 1) {
          value--;
        }

        input.value = value;
      });
    });
  }

  /**
   * Sticky Navigation on Scroll
   */
  function initStickyNav() {
    const nav = document.getElementById('jbweld-anchor-nav');
    if (!nav) return;

    const hero = document.querySelector('.jbweld-hero');
    if (!hero) return;

    const observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            nav.classList.remove('sticky');
          } else {
            nav.classList.add('sticky');
          }
        });
      },
      {
        threshold: 0,
        rootMargin: '-1px 0px 0px 0px'
      }
    );

    observer.observe(hero);
  }

  /**
   * Smooth Scrolling for Anchor Links
   */
  function initSmoothScroll() {
    const anchorLinks = document.querySelectorAll('.jbweld-anchor-link');

    anchorLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        const targetId = this.getAttribute('href');
        const targetSection = document.querySelector(targetId);
        
        if (targetSection) {
          const nav = document.getElementById('jbweld-anchor-nav');
          const offset = nav ? nav.offsetHeight : 0;
          const targetPosition = targetSection.offsetTop - offset;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });

          // Update active link
          anchorLinks.forEach(function(l) {
            l.classList.remove('active');
          });
          this.classList.add('active');
        }
      });
    });

    // Update active link on scroll
    window.addEventListener('scroll', updateActiveAnchorLink);
  }

  /**
   * Update Active Anchor Link Based on Scroll Position
   */
  function updateActiveAnchorLink() {
    const sections = document.querySelectorAll('.jbweld-section[id]');
    const anchorLinks = document.querySelectorAll('.jbweld-anchor-link');
    const nav = document.getElementById('jbweld-anchor-nav');
    const offset = nav ? nav.offsetHeight + 50 : 50;

    let currentSection = '';

    sections.forEach(function(section) {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      
      if (window.pageYOffset >= sectionTop - offset && 
          window.pageYOffset < sectionTop + sectionHeight - offset) {
        currentSection = section.getAttribute('id');
      }
    });

    anchorLinks.forEach(function(link) {
      link.classList.remove('active');
      if (link.getAttribute('href') === '#' + currentSection) {
        link.classList.add('active');
      }
    });
  }

  /**
   * Application Steps - Interactive Switching
   */
  function initApplicationSteps() {
    const steps = document.querySelectorAll('.jbweld-step');
    const visuals = document.querySelectorAll('.jbweld-visual-content');

    if (!steps.length || !visuals.length) return;

    steps.forEach(function(step) {
      step.addEventListener('click', function() {
        const stepNumber = this.getAttribute('data-step');

        // Update active step
        steps.forEach(function(s) {
          s.classList.remove('active');
        });
        this.classList.add('active');

        // Update visual content
        visuals.forEach(function(visual) {
          if (visual.getAttribute('data-visual') === stepNumber) {
            visual.classList.add('active');
          } else {
            visual.classList.remove('active');
          }
        });
      });
    });
  }

  /**
   * Product Navigation Dropdown
   */
  function initProductNavigation() {
    const productNavSelect = document.querySelector('[data-product-nav]');
    
    if (!productNavSelect) return;

    productNavSelect.addEventListener('change', function() {
      const selectedUrl = this.value;
      if (selectedUrl) {
        window.location.href = selectedUrl;
      }
    });
  }

  /**
   * Video Players - Show Preview Until Play Button Clicked
   */
  function initVideoPlayers() {
    const playButtons = document.querySelectorAll('.jbweld-video-play-btn');

    playButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const mediaItem = this.closest('.jbweld-media-item');
        const preview = mediaItem.querySelector('.jbweld-video-preview');
        const player = mediaItem.querySelector('.jbweld-video-player');

        if (preview && player) {
          preview.style.display = 'none';
          player.classList.remove('hidden');
          
          // Auto-play the video
          const video = player.querySelector('video');
          if (video) {
            video.play();
          }
        }
      });
    });
  }

})();

